import React from 'react'
import ModalBody from '../modalbody'
import HowContent from "./howcontent"

const HowitWorks = () => {
    return (
        <ModalBody>
            <div style={{padding: `0 15px`}}>
                <HowContent />
            </div>
        </ModalBody>
    )
}

export default HowitWorks
